exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cmpr-table[data-v-3b29b5da]{overflow-x:auto}.simple-tbl>.head>.row>.col-last[data-v-3b29b5da]{border-right:1px solid #e5e5e5;border-top:1px solid #e5e5e5}.simple-tbl>.body>.row>.comn-col[data-v-3b29b5da],.simple-tbl>.head>.row>.comn-col[data-v-3b29b5da]{background-color:#f8f8f8}.simple-tbl>.body>.row>.odd-group-cols[data-v-3b29b5da],.simple-tbl>.head>.row>.odd-group-cols[data-v-3b29b5da]{background-color:#fff}.simple-tbl>.body>.row>.even-group-cols[data-v-3b29b5da],.simple-tbl>.head>.row>.even-group-cols[data-v-3b29b5da]{background-color:#fefef0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b29b5da","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/ctrl/CmprTable.vue
// module id = 2273
// module chunks = 0